import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { ReplaySubject } from '../util/rxjs';

@Injectable()
export class LocaleGuard  {
  languageLoaded = new ReplaySubject(1);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.languageLoaded.map(() => true);
  }
}
